import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User viewed recently added assets',
  name: 'viewed_recent',
  params: [],
};

export default META;
